/**
 * Transaction Document types for the Access Document DMS integration.
 * Primary key linking documents to transactions is `transactionReference`.
 */

export interface TransactionDocument {
  id: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  documentType: string;
  uploadedAt: string; // ISO 8601
  uploadedByEmail: string;
  uploadedByName?: string;
  transactionReference: string;
  fileUrl?: string; // resolved download URL (populated at runtime)
}

export interface TransactionDocumentsResponse {
  documents: TransactionDocument[];
  totalCount: number;
}

export interface UploadTransactionDocumentPayload {
  transactionReference: string;
  file: File;
  externalId?: string;
  accountCode?: string;
  customerName?: string;
  headerReference?: string;
  transactionDate?: string;
  description?: string;
  transactionType?: string;
}

/**
 * Silent constants passed to the Access Document API on every upload.
 * Neither is shown in the UI — they are predetermined for Credit Control.
 */
export const DOCUMENT_UPLOAD_FOLDER = "ADM";
export const DOCUMENT_UPLOAD_TYPE = "Sales Ledger Transaction";
